module.exports = __webpack_public_path__ + "media/images/com_img03-1cbee8cce4c06a2213d612ad41559776.png";